<div class="dialog" role="document" aria-labelledby="add-permission-title">
  <div class="dialog-header">
    <div class="title-block">
      <span class="dialog-title" id="add-permission-title">Add permission — {{ data.name }}</span>
      <p class="dialog-subtitle">Pick the establishment and role, then the view; search within the view.</p>
    </div>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <div class="field-row">
    <div class="field">
      <label class="field-label" id="add-perm-est-label">Establishment <span aria-hidden="true">*</span></label>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select
          aria-labelledby="add-perm-est-label"
          panelClass="ac-select-panel"
          [disableOptionCentering]="true"
          [formControl]="establishmentId"
          placeholder="Select establishment"
          (selectionChange)="onEstablishmentChange()"
        >
          @for(e of data.establishments; track e.establishmentId){
          <mat-option [value]="e.establishmentId">{{ e.name || ('Establishment #' + e.establishmentId) }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="field-label" id="add-perm-role-label">Role <span aria-hidden="true">*</span></label>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select
          aria-labelledby="add-perm-role-label"
          panelClass="ac-select-panel"
          [disableOptionCentering]="true"
          [formControl]="suremId"
          placeholder="Select role"
          [disabled]="!establishmentId.value"
          (selectionChange)="onRoleChange()"
        >
          @for(r of rolesOfEstablishment(); track r.suremId){
          <mat-option [value]="r.suremId">{{ r.roleName }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="field-row">
    <div class="field">
      <label class="field-label" id="add-perm-view-label">View <span aria-hidden="true">*</span></label>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select
          aria-labelledby="add-perm-view-label"
          panelClass="ac-select-panel"
          [disableOptionCentering]="true"
          [formControl]="viewName"
          placeholder="Select view"
          [disabled]="!suremId.value"
        >
          @for(v of viewOptions(); track v.viewName){
          <mat-option [value]="v.viewName">{{ v.viewLabel || v.viewName }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="field-label" for="add-permission-search">Search permission</label>
      <input
        id="add-permission-search"
        type="text"
        class="text-box-active"
        [placeholder]="canPick() ? 'Permission or role' : 'Select establishment, role and view first'"
        [formControl]="search"
        [disabled]="!canPick()"
      />
    </div>
  </div>

  <div class="perm-scroll">
    @if(canPick()){
    <ul class="perm-list">
      @for(p of visiblePermissions(); track p.svpId){
      <li class="perm-row">
        <div class="perm-text">
          <span class="perm-name">{{ p.permLabel || p.permission }}</span>
          @if(p.roles){ <span class="perm-meta">Default for: {{ p.roles }}</span> }
        </div>
        @if(isGranted(p.svpId)){
        <span class="granted">Granted</span>
        } @else {
        <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading" (click)="grant(p)">Grant</button>
        }
      </li>
      } @empty {
      <li class="perm-row"><span class="empty-note">{{ search.value ? 'No permissions match the search.' : 'No permissions available in this view.' }}</span></li>
      }
    </ul>
    } @else {
    <p class="empty-note">Select the establishment, role and view to list the permissions.</p>
    }
  </div>

</div>

<app-loader [isLoading]="isLoading"></app-loader>
